import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AngularFireAuth } from '@angular/fire/compat/auth';        // ← add this
import { APIServiceService } from '../api/apiservice.service';
import { APIResponse } from '../models/api-response.model';
import { User } from '../models/user.model';
import ErrorsLibrary from '../errors/errors-library';
import AppError from '../errors/error';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserAuthService {
  AUTH_TOKEN_COOKIE_KEY = 'rs_auth_token';
  user: User | null = null;
  loggedIn = false;

  constructor(
    private afAuth: AngularFireAuth,          // ← inject AngularFireAuth
    private apiService: APIServiceService,
    private router: Router,
    private cookieService: CookieService
  ) {
    // 1) Subscribe to Firebase authState changes
    this.afAuth.authState
      // .pipe(take(1)) // OPTIONALLY only take the first value if you only care initial load
      .subscribe(firebaseUser => {
        this.loggedIn = !!firebaseUser;
       // console.log("Auth state changed 2", this.loggedIn)
        if (this.loggedIn) {
          // You now have a firebaseUser.uid / email / etc.
          // If you need to fetch your own API’s JWT, you could do it here:
          firebaseUser.getIdToken()
            .then(idToken => {
              console.log("Logged in ", idToken)
              this.loggedIn = true
              // this.loginWithGoogleToken(idToken)
            })
            .catch(err => console.error('Token fetch failed', err));
        } else {
          // Not logged in → clean up
          this.user = null;
          this.cookieService.delete(this.AUTH_TOKEN_COOKIE_KEY);
        }
      });

    // 2) Also try any saved cookie-based token for pure-JWT sessions
    const savedToken = this.cookieService.get(this.AUTH_TOKEN_COOKIE_KEY);
    if (savedToken) {
      this.checkAccessToken(savedToken);
    }
  }

  private loginWithGoogleToken(token: string): Promise<User | AppError> {
    return new Promise((resolve, reject) => {
      this.apiService.user.login(token)
        .then((response: APIResponse) => {
          if (response.success) {
            // store your own JWT in a cookie
            this.cookieService.set(this.AUTH_TOKEN_COOKIE_KEY, response.data.jwtToken, 30);
            this.user = new User().deserialize(response.data.user);
            this.loggedIn = true;
            this.router.navigate(['/calendar'], { replaceUrl: true });
            resolve(this.user);
          } else {
            this.signOut();
            reject(ErrorsLibrary.login.userNotFound);
          }
        })
        .catch(err => {
          this.signOut();
          reject(ErrorsLibrary.login.loginError);
        });
    });
  }

  checkAccessToken(token: string) {
    this.apiService.user.authenticateToken(token)
      .then(response => {
        if (response.success) {
          this.user = new User().deserialize(response.data.user);
          this.loggedIn = true;
        } else {
          this.user = null;
          this.loggedIn = false;
        }
      })
      .catch(err => console.error(err));
  }

  signOut(): void {
    // tell Firebase to sign out (will also emit authState = null)
    this.afAuth.signOut().finally(() => {
      this.cookieService.delete(this.AUTH_TOKEN_COOKIE_KEY);
      this.user = null;
      this.loggedIn = false;
      this.router.navigate(['/']);
    });
  }
}